<template>
	<div>
		<Layout :navFixed="true" :invert="true" :loading="loading" :withImage="true" class="bg-white">
			<div class="container " style="margin-top:120px;padding-bottom:170px">
				<div class="row">
					<div class="col mt-4">
						<div>
							<h1 class="title  mb-3">Contá con <strong>nosotros</strong></h1>

							<p class="lead-text ">
								¿Tenés alguna duda? No dudes en contactarnos!
							</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col col-md-6">
						
						<div class="p-5" style="max-width:500px" v-if="!sended">
							<FormulateForm name="form" v-model="form" @submit="save">
								<FormulateInput
									label="Nombre y apellido"
									name="name"
									ref="first"
									validation-name="Nombre y apellido"
									validation="required"
								/>
								<FormulateInput
									label="Correo electrónico"
									name="email"
									type="email"
									validation-name="Email"
									validation="required"
								/>
								<FormulateInput
									label="Teléfono"
									name="phone"
									validation-name="Teléfono"
									validation="required"
								/>
								<FormulateInput
									label="Mensaje"
									name="message"
									type="textarea"
									validation-name="Mensaje"
									validation="required|max:200,length"
								/>

								<div class="btn btn-block btn-primary" @click="$formulate.submit('form')">
									Enviar mensaje
								</div>
							</FormulateForm>
						</div>
						<div class="p-5" style="max-width:500px" v-if="sended">
							<h1 class="title  mb-3">Mensaje <strong>enviado!</strong></h1>
							<p class="lead-text ">
								Gracias por ponerte en contacto con nosotros!<br />
								En breve atenderemos tu mensaje y nos pondremos en contacto con usted.
							</p>
						</div>
					</div>
					<div class="col col-md-6">
						<div class="mt-4 pt-5">
							<GmapMap
								:center="{lat:-34.8386912, lng:-56.2608641}"
								:zoom="15"
								style="width: 500px; height: 390px"
								:options="mapOptions"
							>
							<GmapMarker
								:position="{lat:-34.8386912, lng:-56.2608641}"
								:clickable="false"
								:draggable="false"
							/>
							</GmapMap>

						</div>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"

export default {
	name: "Home",
	metaInfo: {
		title: "Contactanos"
	},
	components: {
		Layout
	},
	data() {
		return {
			loading: false,
			sended: false,
			form: {
				name: "",
				email: "",
				phone: "",
				message: this.$route.query.body
					? this.$route.query.body.replace(
							/\/n/g,
							`
`
					  )
					: ""
			},
			mapOptions:{
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.$refs.first.$el.querySelector(".formulate-input-element input").focus()
		})
	},
	methods: {
		save() {
			if (!this.loading) {
				this.loading = true
				const data = {
					subject: "Mensaje de contacto web",
					name: this.form.name,
					phone: this.form.phone,
					email: this.form.email,
					message: this.form.message
				}

				this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: MessageInput!) {
								messageCreate(data: $data) {
									id
								}
							}
						`,
						variables: {
							data
						}
					})
					.then(() => {
						this.loading = false
						this.sended = true
						// this.$gtag.event('contactMessageSended')
					})
					.catch((error) => {
						this.parseGQLErrors(error)
						this.loading = false
					})
			}
		}
	}
}
</script>

<style scoped>
.group ::v-deep .list-group-item {
	border: none;
	border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.group-item-head {
	font-size: 22px;
	padding: 3px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.row ::v-deep textarea {
	height: 100px;
}
</style>
